export default "__VITE_ASSET__Bwpzka4z__"